import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const CentreInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: self-start;
  margin-bottom: 10px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 0.25rem;
  font-weight: normal;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#15aee5")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  font-weight: normal;
  width: auto;
  padding: 5px 10px;
  font-size: 14px;
  font-family: lato;
  margin-top: 6px;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: #767676;
  font-size: 14px;
  font-weight: 400;
  padding-left: 12px;
  margin-bottom: 10px;
`;

export const SubTitleBold = styled.div`
  justify-self: auto;
  color: #004c7f;
  font-size: 14px;
  font-weight: 700;
  padding-left: 0px;
  margin-bottom: 10px;
  flex-shrink: 0;
  width: ${(props) => (props?.width ? props.width : "44%")};
`;

export const DescriptionData = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;

export const FlexRowHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
